import VueCompositionApi from '@vue/composition-api'
import Vue from 'vue'

import App from './App'

Vue.use(VueCompositionApi)

// Register all game-specific components.
for (const components of [
  require.context('@world/components', true, /\.(js|vue)$/i),
]) {
  components.keys().forEach(key => {
    const componentConfig = components(key)
    const componentName = key.split('/').pop().replace(/\.\w+$/, '')
    const component = componentConfig.default || componentConfig
    Vue.component(componentName, component)
  })
}

export {App as component}
export function mount (opts) {
  new Vue({
    render (h) {
      return h(App, {
        attrs: opts.props,
        on: opts.on,
      })
    },
  }).$mount(opts.el)
}
